import React from 'react';

function StatusDot({ status = 'running', pulse = false }) {
  return (
    <span className={`status-dot status-${status} ${pulse ? 'is-pulsing' : ''}`}>
      <span />
    </span>
  );
}

export default StatusDot;